import nuveiManager from '@/library/payments/nuveiManager'
import pnmManager from '@/library/payments/pnmManager'
import sightlineManager from './sightlineManager'

function checkIsRedirectedFromInAppBrowserAndIntercept () {
  nuveiManager.checkIsRedirectedFromInAppBrowserAndIntercept()
  pnmManager.checkIsRedirectedFromInAppBrowserAndIntercept()
  sightlineManager.checkIsRedirectedFromInAppBrowserAndIntercept()
}

export default {
  checkIsRedirectedFromInAppBrowserAndIntercept
}



// WEBPACK FOOTER //
// ./src/library/payments/paymentsManager.js